module.exports = __webpack_public_path__ + "img/thumbnail_AfricanPenguin_f_normal.c65e9535.png";